import { render, staticRenderFns } from "./app-alert.vue?vue&type=template&id=5389ecea"
import script from "./app-alert.vue?vue&type=script&lang=ts"
export * from "./app-alert.vue?vue&type=script&lang=ts"
import style0 from "./app-alert.vue?vue&type=style&index=0&id=5389ecea&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/volateq-web-app/volateq-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5389ecea')) {
      api.createRecord('5389ecea', component.options)
    } else {
      api.reload('5389ecea', component.options)
    }
    module.hot.accept("./app-alert.vue?vue&type=template&id=5389ecea", function () {
      api.rerender('5389ecea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/app-alert/app-alert.vue"
export default component.exports